import { render, staticRenderFns } from "./ActionBlock.vue?vue&type=template&id=dcd12a5a&scoped=true&"
import script from "./ActionBlock.vue?vue&type=script&lang=js&"
export * from "./ActionBlock.vue?vue&type=script&lang=js&"
import style0 from "./ActionBlock.vue?vue&type=style&index=0&id=dcd12a5a&lang=scss&scoped=true&"
import style1 from "./ActionBlock.vue?vue&type=style&index=1&id=dcd12a5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd12a5a",
  null
  
)

export default component.exports